import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { ContinuosReportingType } from '../ContinuosReporting';
import { validateStatementByProjectIdAndStatementId } from 'lib/api_ts/continuosReportingApi';
import { useLocation } from 'react-router-dom-v5-compat';
import StatusBar from 'components/StatusBar';

interface ContinuosReportingValidateModalProps {
	data: ContinuosReportingType;
	fetchData: () => void;
}

const ContinuosReportingValidateModal: React.FC<ContinuosReportingValidateModalProps> = ({ data, fetchData }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { pathname } = useLocation();
	const projectId = pathname.split('/')[2];

	const blankStatusBar = {
		status: undefined,
		message: '',
		timeout: undefined,
	};

	const [statusBar, setStatusBar] = useState(blankStatusBar);
	const resetStatusBar = () => {
		setStatusBar(blankStatusBar);
	};

	const handleValidate = async () => {
		setStatusBar({
			status: 'elaborating',
			message: 'Validazione Continuos Reporting in corso',
			timeout: false,
		});
		try {
			await validateStatementByProjectIdAndStatementId(projectId, data.id);
			setStatusBar({
				status: 'success',
				message: 'Continuos Reporting validato con successo',
				timeout: true,
			});
			setTimeout(() => {
				setIsModalOpen(false);
				resetStatusBar();
				fetchData();
			}, 2000);
		} catch (error) {
			setStatusBar({
				status: 'error',
				message: 'Errore durante la validazione del Continuos Reporting',
				timeout: true,
			});
			setTimeout(() => {
				resetStatusBar();
			}, 2000);
		}
	};

	return (
		<>
			<Button onClick={() => setIsModalOpen(true)}>Valida rendiconto</Button>

			<Modal show={isModalOpen} onHide={() => setIsModalOpen(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Attenzione</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="my-3">
						<span>Sei sicuro di voler validare il report?</span>
					</div>
					{statusBar.status ? (
						<StatusBar status={statusBar.status} message={statusBar.message} timeout={statusBar.timeout}>
							<></>
						</StatusBar>
					) : null}
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={handleValidate}>Valida</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default ContinuosReportingValidateModal;
